import { type DetailsPageProps } from 'app/main/components/page-layouts';

import ItemsDetailsTab from './tabs/ItemsDetailsTab';
import ItemsPricingsTab from './tabs/ItemsPricingsTab';
import ItemsMerchPointsTab from './tabs/ItemsMerchPointsTab';

const tabs: DetailsPageProps['tabs'] = [
	{
		id: 'summary',
		title: 'TAB_SUMMARY',
		content: props => <ItemsDetailsTab {...props} />
	},
	{
		id: 'pricings',
		title: 'TAB_ITEMS_PRICINGS',
		disabled: ({ isEdit }) => isEdit,
		content: props => <ItemsPricingsTab {...props} />
	},
	{
		id: 'merch-points',
		title: 'TAB_ITEMS_MERCHPOINTS',
		disabled: ({ isEdit }) => isEdit,
		content: props => <ItemsMerchPointsTab {...props} />
	}
];

export default tabs;
